var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{attrs:{"id":"app"}},[_c('NavBar'),_c('v-main',[_c('router-view',{attrs:{"id":"main"}})],1),_c('app-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }